import { Autoplay } from "./modules/autoplay";
import { Alert } from "./modules/alert";
import { App } from "./app";
import { Carousel } from "./modules/carousel";
import { Disclosure } from "./modules/disclosure";
import { Drawer } from "./modules/drawer";
import { LazyLoader } from "./modules/lazy-loader";
import { NavigationBar } from "./modules/navigation-bar";
import { PlayButton } from "./modules/play-button";
import { Video } from "./modules/video";
import { init as CookieConsent } from "./modules/cookie-consent";

let app = App();

CookieConsent();

let lazyLoader = LazyLoader();
lazyLoader.update();

app.start();
app.register("drawer", Drawer);
app.register("disclosure", Disclosure);
app.register("alert", Alert);
app.register("navigation-bar", NavigationBar);
app.register("video", Video);
app.register("carousel", Carousel);
app.register("autoplay", Autoplay);
app.register("play-button", PlayButton);

const accordionButtons = document.querySelectorAll(".accordion-button");

accordionButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const item = button.parentElement;
    const isExpanded = item.classList.contains("is-expanded");

    // Toggle the clicked item
    if (!isExpanded) {
      item.classList.add("is-expanded");
    } else {
      item.classList.remove("is-expanded");
    }
  });
});
